import profileOverlayText from 'assets/svgs/OverlayText-profile.svg?url';
import profileImgLarge from 'assets/social/profile-large.jpg';
import profileImgPlaceholder from 'assets/social/profile-placeholder.jpg';
import profileImg from 'assets/social/profile.jpg';
import {Button} from 'components/Button';
import {DecoderText} from 'components/DecoderText';
import {Divider} from 'components/Divider';
import {Heading} from 'components/Heading';
import {Image} from 'components/Image';
import {Link} from 'components/Link';
import {Section} from 'components/Section';
import {Text} from 'components/Text';
import {Transition} from 'components/Transition';
import {Fragment, useState} from 'react';
import {media} from 'utils/style';
import styles from './Profile.module.css';

const ProfileText = ({visible, titleId}) => (
    <Fragment>
        <Heading className={styles.title} data-visible={visible} level={3} id={titleId}>
            <DecoderText text="Hi there, I'm Tim." start={visible} delay={500}/>
        </Heading>

        <Text className={styles.description} data-visible={visible} size="l" as="p">
            I&apos;m a Senior Software Engineer at{' '}
            <Link href="https://www.starboardintelligence.com/">Starboard Maritime Intelligence</Link>,
            based in Wellington, New Zealand, working on system design &amp; architecture at scale.
        </Text>

        <Text className={styles.description} data-visible={visible} size="l" as="p">
            I&apos;m drawn to interesting and challenging tech. My background spans international tax administration systems,
            AI startups working on NLP and large language models (prior to ChatGPT), computer vision for video surveillance,
            and hardware integration projects.
        </Text>

        <Text className={styles.description} data-visible={visible} size="l" as="p">
            I studied at{' '}
            <Link href="https://www.wgtn.ac.nz/">Victoria University of Wellington</Link> and graduated
            with a Bachelor of Engineering (Hons) in Software Engineering with First Class Honours.
        </Text>

        <Text className={styles.description} data-visible={visible} size="l" as="p">
            If you&apos;re interested in the tools and software I use, check out my{' '}
            <Link href="/stack">stack</Link>.
        </Text>

        <Text className={styles.description} data-visible={visible} size="l" as="p">
            Here I share technical deep-dives, side projects, and things I find interesting along the way.
        </Text>

    </Fragment>
);

export const Profile = ({id, visible, sectionRef}) => {
    const [focused, setFocused] = useState(false);
    const titleId = `${id}-title`;

    return (
        <Section
            className={styles.profile}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            as="section"
            id={id}
            ref={sectionRef}
            aria-labelledby={titleId}
            tabIndex={-1}
        >
            <Transition in={visible || focused} timeout={0}>
                {visible => (
                    <div className={styles.content}>
                        <div className={styles.column}>
                            <ProfileText visible={visible} titleId={titleId}/>
                            <Button
                                secondary
                                className={styles.button}
                                data-visible={visible}
                                href="/contact"
                                icon="send"
                            >
                                Send me a message
                            </Button>
                        </div>
                        <div className={styles.column}>
                            <div className={styles.tag} aria-hidden>
                                <Divider
                                    notchWidth="64px"
                                    notchHeight="8px"
                                    collapsed={!visible}
                                    collapseDelay={1000}
                                />
                                <div className={styles.tagText} data-visible={visible}>
                                    About Me
                                </div>
                            </div>
                            <div className={styles.image}>
                                <Image
                                    reveal
                                    delay={100}
                                    placeholder={profileImgPlaceholder}
                                    srcSet={[profileImg, profileImgLarge]}
                                    sizes={`(max-width: ${media.mobile}px) 100vw, 480px`}
                                    alt="Tim McDermott"
                                />
                                <svg
                                    aria-hidden="true"
                                    width="135"
                                    height="765"
                                    viewBox="0 0 135 765"
                                    className={styles.svg}
                                    data-visible={visible}
                                >
                                    <use href={`${profileOverlayText}#OverlayText-profile`}/>
                                </svg>
                            </div>
                        </div>
                    </div>
                )}
            </Transition>
        </Section>
    );
};
